<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title
      >Upload Spreadsheet for Bulk User Registration</mat-card-title
    >
    <button
      mat-fab
      (click)="downLoadFile()"
      color="accent"
      [disabled]="!isSuperAdmin"
      [ngClass]="
        isSuperAdmin
          ? 'mat-mini-fab mat-accent'
          : 'mat-mini-fab mat-button-disabled'
      "
      style="
        position: absolute;
        right: 20px;
        top: 8px;
        width: 35px;
        height: 35px;
      "
      matTooltip="Download Sample"
    >
      <span class="mat-mdc-button-wrapper">
        <i class="material-icons" style="font-size: 30px">download</i>
      </span>
    </button>
    <mat-card-content>
      <div class="row">
        <div class="col-md-12 form-group">
          <div class="instruction-box">
            <ul class="instruction-list">
              <li>
                Upload spreadsheet to register multiple users; only
                <span class="highlight">active users</span> will receive
                passwords via email.
              </li>
              <li>
                <span class="highlight">First Name</span>,
                <span class="highlight">Last Name</span>, and
                <span class="highlight">Employee ID</span> ≤
                <span class="highlight">20 characters</span>;
                <span class="highlight">Phone Number</span> must be
                <span class="highlight">10-digit number</span>.
              </li>
              <li>
                Only <span class="highlight">lowercase emails</span> with domain
                <span class="highlight">tsiplc.com</span> are allowed.
              </li>
              <li>
                Do <span class="highlight">not rename</span> the sheet; only the
                <span class="highlight">first sheet</span> will be processed.
              </li>
              <li>
                Use only values from the
                <span class="highlight">sample file</span> for
                <span class="highlight">Role, Status, State, and City</span>;
                others will be rejected.
              </li>
              <li>
                Click <span class="highlight">Download</span> to get the sample
                format. A <span class="highlight">result file</span> will be
                downloaded after upload, showing success/failure.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 form-group">
          <input
            type="file"
            class="form-control"
            [disabled]="!isSuperAdmin"
            (change)="uploadedFile($event)"
            placeholder="Upload file"
          />
        </div>
      </div>
      <div
        *ngIf="isLoaderResult"
        style="
          display: flex;
          justify-content: content;
          align-items: center;
          position: absolute;
          top: 40%;
          left: 35%;
        "
      >
        <mat-spinner color="warn"></mat-spinner>
      </div>
    </mat-card-content>
  </mat-card>
</div>
